const BhVampFlag = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.14163 7.6408C2.98564 7.69232 2.85179 7.74382 2.75 7.78574V10.625C2.75 10.8321 2.58211 11 2.375 11C2.16789 11 2 10.8321 2 10.625V2.19957C2 1.86951 2.18901 1.54952 2.51995 1.4169C2.91337 1.25925 3.67254 1 4.44643 1C5.05076 1 5.63784 1.29092 6.12731 1.53346L6.16638 1.55282C6.70722 1.82058 7.14287 2.02778 7.55357 2.02778C7.97346 2.02778 8.40735 1.93107 8.76363 1.82015C9.32404 1.64568 10 2.03472 10 2.69358V7.23099C10 7.56104 9.81099 7.88103 9.48005 8.01365C9.08663 8.17131 8.32746 8.43056 7.55357 8.43056C6.94924 8.43056 6.36215 8.13964 5.87269 7.89709L5.83362 7.87773C5.29278 7.60997 4.85713 7.40278 4.44643 7.40278C3.9872 7.40278 3.51222 7.51839 3.14163 7.6408Z"
      fill="currentColor"
    />
  </svg>
)

export default BhVampFlag
